import React from "react";
import "./exlink.scss";
import { Link } from "gatsby";
const exlink = () => (
    <>
        <div className="exlink_container media">
            <Link to="/" className="exlink">works</Link>
            <Link to="" className="exlink">blog</Link>
            <Link to="/about" className="exlink">about</Link>
        </div>
        
    </>
)
  
 
  export default exlink;
  